import { Grid } from '@mui/material';

import type { PropertyKindEnum } from '@/types';
import { FiltersBlock } from './FiltersBlock';
import { icons } from './Icons';

interface PropertyKindOption {
  label: string;
  value: PropertyKindEnum;
}

interface PropertyTypeSectionProps {
  onPropertyKindChange: (value: PropertyKindEnum, name?: string) => void;
  onPropertyTypeTabChange: (value: number) => void;
  options: PropertyKindOption[];
  propertyTypeTab: number;
  selectedPropertyKinds: PropertyKindEnum[];
}

export const PropertyTypeSection = ({
  onPropertyKindChange,
  onPropertyTypeTabChange,
  options,
  propertyTypeTab,
  selectedPropertyKinds,
}: PropertyTypeSectionProps) => {
  return (
    <Grid item xs={12}>
      <FiltersBlock
        icon={<icons.PropertyType />}
        name='propertyKind'
        type='button'
        size='large'
        title='Property type'
        options={options}
        activeButton={selectedPropertyKinds}
        onClick={onPropertyKindChange}
        dataQa='property_type'
        propertyTypeTab={propertyTypeTab}
        setPropertyTypeTab={onPropertyTypeTabChange}
      />
    </Grid>
  );
};
